<template>
  <b-modal id="questionnaire-link-modal"
           :title="$t('send_link_to_patient')"
           size="sm"
           centered
           hide-footer>
    <div class="channels-menu">
      <a v-if="allowToSendViaWhatsapp"
         @click="sendViaMessenger('whatsapp')">
        Whatsapp
      </a>
      <a v-if="allowToSendViaTelegram"
         @click="sendViaMessenger('telegram')">
        Telegram
      </a>
      <a v-if="allowToSendViaTelegramBot"
         @click="sendViaMessenger('telegram_bot')">
        Telegram bot
      </a>
    </div>
    <div class="mt-3" v-if="bookingQuestionnaireLink">
      <InputGroup :readonly="true"
                  :label="$t('link')"
                  inputRowClass="d-flex align-items-center"
                  :value="bookingQuestionnaireLink">
        <a class="copy-to-clipboard pl-3 pr-2 pointer"
           @click="copyToClipboard"
           v-b-tooltip
           :title="copied ? $t('copied') : $t('copy_to_clipboard')">
          <CopySvg v-if="!copied"/>
          <TickSvg class="svg-light svg-size-md" v-if="copied"/>
        </a>
      </InputGroup>

    </div>
  </b-modal>
</template>

<script setup>
import {useStore} from "vuex"
import {computed, getCurrentInstance, onBeforeMount, ref} from "vue"
import { PatientService } from "@/services/api/patient.api.service"
import InputGroup from "@/components/form/InputGroup.vue"
import CopySvg from '@/assets/svg-vue/patients/copy.svg'
import TickSvg from '@/assets/svg-vue/form/tick.svg'

const store = useStore()

const instance = getCurrentInstance()
let bvModal = null
let i18n = null
let noty = null

const copied = ref(false)

const loading = computed(() => store.state.loading)
const patient = computed(() => store.state.patient.patient)
const telegramBotEnabled = computed(() => store.getters.telegramBotEnabled)
const allowToSendViaWhatsapp = computed(() => store.getters.canSendViaWhatsApp)
const allowToSendViaTelegram = computed(() => store.getters.canSendViaTelegram)
const allowToSendViaTelegramBot = computed(() => telegramBotEnabled.value && patient.value?.telegram_chat)
const bookingQuestionnaireLink = computed(() => patient.value?.bookingQuestionnaireLink || null)

onBeforeMount(() => {
  bvModal = instance?.ctx?._bv__modal
  i18n = instance?.ctx?.$i18n
  noty = instance?.appContext?.app?.noty
})

const sendViaMessenger = async (messenger) => {
  if(loading.value) return
  try {
    const res = await PatientService.sendAnketaViaMessenger(patient.value.id, {
      messenger
    })
    if(res?.data === 0) {
      noty.info(i18n.t('sent'))
      bvModal.hide('questionnaire-link-modal')
    } else {
      noty.error(i18n.t('error_message'))
    }
  } catch (e) {
    console.log(e)
  }
}

const copyToClipboard = () => {
  navigator.clipboard.writeText(bookingQuestionnaireLink.value)
  copied.value = true
  setTimeout(() => copied.value = false, 2000)
}
</script>

<style scoped lang="scss">
.channels-menu {
  > a {
    display: block;
    padding: 10px 0;
    color: $blue-color !important;
    text-decoration: none;
    border: 1px solid $blue-color;
    text-align: center;
    margin-bottom: 10px;
    border-radius: 10px;
    cursor: pointer;

    &:hover {
      background-color: $light-blue;
      color: $blue-color;
    }
  }
}
</style>
